export default __webpack_public_path__ + "cocoa_doorbell_v6.a3f7d9db.png";